<section id="features" class="section section-2">

  <div class="container">

    <div class="text-center mb-5">

      <span class="section-badge">
        {{ 'features.badge' | translate }}
      </span>

      <h2 class="section-title">
        {{ 'features.title' | translate }}
      </h2>

      <p class="section-subtitle">
        {{ 'features.subtitle' | translate }}
      </p>

    </div>

    <div class="row g-4">

      @for (feature of features; track feature) {

      <div class="col-xl-3 col-lg-4 col-md-6">

        <div class="feature-card d-flex flex-column align-items-center">

          <div class="feature-icon">
            <i [ngClass]="feature.icon"></i>
          </div>

          <h5>
            {{ feature.title }}
          </h5>


        </div>

      </div>

      }

    </div>

  </div>

</section>